import { getActionHandler, getInitialState } from "../helpers/crudReducers";

const initialState = getInitialState("CRITICAL_PATH_VERSIONS");
const CRUD_ACTION_HANDLERS = getActionHandler("CRITICAL_PATH_VERSIONS");

export default function criticalpathVersions(state = initialState, action) {
  const handler = CRUD_ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
